<!--DomainGuide/index-->

<template>
    <div class="mx-auto px-6 py-12 xl:max-w-[1528px]">
        <div class="mb-[42px]">
            <h1 class="text-3xl font-medium text-gray-900">
                {{ $t("vue.add_your_first_domain_to_get_started") }}
            </h1>
            <p class="mt-2 text-sm text-gray-600">
                {{ $t("vue.add_your_first_domain_to_get_started_desc") }}
            </p>
        </div>

        <DomainWizard :domains-count="domainsCount" :domains="domains" />
    </div>

    <TrialEndedPopup />
</template>

<script setup lang="ts">
import { useTranslations } from "@/composables/useTranslations.ts";
import route from "ziggy-js";
import { create } from "@/composables/useNotifications.ts";
import DateRangePicker from "@/Pages/Reports/components/DateRangePicker.vue";
import DomainWizard from "@/components/Special/DomainWizard.vue";
import InfoCard from "@/components/Content/InfoCard.vue";

const { t } = useTranslations();

const props = defineProps({
    domainsCount: { type: Number, default: 0 },
    domains: { type: Array, default: () => [] },
});

const { domainsCount, domains } = props;
</script>

<style scoped></style>
